import { render, staticRenderFns } from "./DiagnosticPayment.vue?vue&type=template&id=7435ea90&"
import script from "./DiagnosticPayment.vue?vue&type=script&lang=js&"
export * from "./DiagnosticPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports